export function getLeaseDealsDataWithPhotos(leaseDealsData, photos) {
  const leaseDealsWithPhoto = leaseDealsData.deals.map(deal => {
    const { styleId } = deal;
    const photo = photos?.find(({ styleIds }) => styleIds?.[styleId]);

    return {
      ...deal,
      photo,
    };
  });

  return {
    ...leaseDealsData,
    deals: leaseDealsWithPhoto,
  };
}
